<template>
  <div>
    <MainNav />
    <main class="container py-4">
      <div class="mb-3">
        <h1 class="h3 mb-1">Fiche de collecte</h1>
        <p class="text-muted mb-0">Choisissez un relais, cochez les courses ramassées, puis collectez.</p>
      </div>
      <div v-if="forbidden" class="alert alert-danger">Réservé au collecteur ou au fondateur.</div>
      <div v-else-if="error" class="alert alert-danger">{{ error }}</div>

      <template v-else>
        <div class="mb-3">
          <label class="form-label">Point relais</label>
          <select class="form-select" v-model="relayId" @change="loadItems">
            <option :value="null">— choisir —</option>
            <option v-for="r in relays" :key="r.service_point_id" :value="r.service_point_id">
              {{ r.name }} ({{ r.city }}) — {{ euro(r.collectable) }}
            </option>
          </select>
        </div>

        <div v-if="loadingItems" class="alert alert-secondary">Chargement des courses…</div>
        <template v-else-if="relayId">
          <div v-if="items.length === 0" class="alert alert-success">Aucune course à collecter ici.</div>
          <table v-else class="table table-sm align-middle">
            <thead><tr>
              <th style="width:36px"></th><th>Course</th><th>Date</th><th>Client</th>
              <th class="text-end">Dû</th><th class="text-end" style="width:130px">À collecter</th>
            </tr></thead>
            <tbody>
              <tr v-for="it in items" :key="it.shipment_id">
                <td><input type="checkbox" v-model="it.checked" @change="onToggle(it)"></td>
                <td>{{ it.tracking_number || it.shipment_id }}</td>
                <td>{{ it.date }}</td>
                <td>{{ it.client }}</td>
                <td class="text-end">{{ euro(it.available) }}</td>
                <td class="text-end"><input type="number" step="0.01" min="0" class="form-control form-control-sm text-end"
                  :max="it.available" v-model="it.amount" :disabled="!it.checked"></td>
              </tr>
            </tbody>
          </table>
          <div v-if="items.length" class="d-flex justify-content-between align-items-center">
            <div>Sélection : <strong>{{ euro(selectedTotal) }}</strong> ({{ selectedCount }} course(s))</div>
            <button class="btn btn-primary" :disabled="selectedCount===0 || busy" @click="collect">
              {{ busy ? 'En cours…' : 'Collecter la sélection' }}
            </button>
          </div>
        </template>

        <div v-if="message" class="alert mt-3" :class="messageOk ? 'alert-success' : 'alert-danger'">{{ message }}</div>
      </template>
    </main>
  </div>
</template>

<script>
import axios from 'axios'
import MainNav from '@/components/MainNav.vue'
export default {
  name: 'CollectionSheet',
  components: { MainNav },
  data() { return { relays: [], relayId: null, items: [], loadingItems: false, busy: false,
    forbidden: false, error: '', message: '', messageOk: false } },
  computed: {
    selected() { return this.items.filter(i => i.checked && Number(i.amount) > 0) },
    selectedCount() { return this.selected.length },
    selectedTotal() { return this.selected.reduce((s,i)=>s+Number(i.amount),0) },
  },
  mounted() { this.loadRelays() },
  methods: {
    euro(v){ return `${Number(v).toFixed(2)} €` },
    onToggle(it){ if(!it.checked) it.amount = it.available },
    key(){ return 'col-' + Date.now() + '-' + Math.floor(Math.random()*1e6) },
    async loadRelays() {
      try { const { data } = await axios.get('/api/v1/cash/collector/dashboard/'); this.relays = data.relays }
      catch(e){ if(e.response?.status===403) this.forbidden=true; else this.error='Chargement impossible.' }
    },
    async loadItems() {
      this.message=''; this.items=[]; if(!this.relayId) return
      this.loadingItems=true
      try {
        const { data } = await axios.get(`/api/v1/cash/collector/relays/${this.relayId}/open-items/`)
        this.items = data.items.map(i => ({ ...i, checked:false, amount:i.available }))
      } catch(e){ this.error='Chargement des courses impossible.' }
      finally { this.loadingItems=false }
    },
    async collect() {
      this.busy=true; this.message=''
      try {
        const items = this.selected.map(i => ({ shipment_id:i.shipment_id, amount:i.amount }))
        await axios.post('/api/v1/cash/transfers/relay-collector/',
          { service_point_id:this.relayId, items }, { headers:{ 'Idempotency-Key':this.key() } })
        this.messageOk=true; this.message=`Collecte initiée : ${this.euro(this.selectedTotal)}. Confirmation relais + collecteur requise pour finaliser.`
        await this.loadItems(); await this.loadRelays()
      } catch(e){ this.messageOk=false; this.message = e.response?.data?.detail || "Échec de la collecte." }
      finally { this.busy=false }
    },
  },
}
</script>
